'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = namespace;

var _utils = require('../utils');

/**
 * Namespace plugin.
 *
 * @param {String} msgs Messages.
 * @param {Object} [options={}] Plugin options.
 * @param {String} [options.name=null] Namespace name.
 * @param {Boolean} [options.capitalize=false] Capitalize.
 * @param {Object} [options.styles={}] Plugin styles.
 * @param {Object} level Level.
 * @param {String} level.name Level name.
 * @param {Object} level.options Level options.
 *
 * @returns {Object} Plugin result.
 */
function namespace(msgs, _ref, level) {
  var _ref$name = _ref.name,
      name = _ref$name === undefined ? null : _ref$name,
      _ref$capitalize = _ref.capitalize,
      capitalize = _ref$capitalize === undefined ? false : _ref$capitalize,
      _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles;

  var formattedMsg = '';
  var s = {};

  if (name) {
    if (capitalize) {
      name = (0, _utils.capitalize)(name);
    }
    formattedMsg = '[' + name + ']';

    s = _extends({}, defaultStyles, levelStyles[level.name], styles || {});
  }

  return { before: formattedMsg, styles: s };
}

var defaultStyles = {
  color: 'white',
  background: '#000000',
  padding: '3px 5px'
};

var levelStyles = {
  log: {
    background: '#000000'
  },
  info: {
    background: '#219bff'
  },
  warn: {
    background: '#ffea2d',
    color: 'inherit'
  },
  error: {
    background: '#e52d34'
  }
};
module.exports = exports['default'];